/*eslint-disable*/
import { useState, useEffect } from "react";
import styled from '@emotion/styled'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';

const PageBackWrapper = styled.div`
    cursor: pointer;
    margin-bottom: 24px;

    .back-to-feature-requests-text {
        font-size: 16px;
        display: inline-block;
        color: #525866;
        line-height: 24px;
        margin-left: 8px;
        font-weight: 500;
        margin-bottom: 0;
    }

    .back-to-feature-requests-icon {
        color: #525866;
        font-size: 12px;
        padding-bottom: 1px;
    }

`;

const PageBack = ({
    backHandler,
    backText,
}) => {
    return (
        <PageBackWrapper>
            <div className="back-to-feature-requests" onClick={backHandler}>
                <FontAwesomeIcon icon={faChevronLeft} className="back-to-feature-requests-icon" />
                <p className="back-to-feature-requests-text">{backText}</p>
            </div>
        </PageBackWrapper>
    );
};

export default PageBack;
